import { template as template_67f4800a22034e7db96f83f11d5e8fa3 } from "@ember/template-compiler";
import { AnimationTypeValues } from 'eflex/constants/jem/instruction-animation-types';
import { AnimationEventValues } from 'eflex/constants/jem/instruction-animation-events';
import { DataTypes, ModelValues, BOMValues } from 'eflex/constants/jem/instruction-data-types';
import { reject, isEmpty } from 'ramda';
import BsForm from 'eflex/components/bs-form';
import BsButton from 'eflex/components/bs-button';
import { t } from 'ember-intl';
import { on } from '@ember/modifier';
import { fn } from '@ember/helper';
import { findBy, isPresent } from '@eflexsystems/ember-composable-helpers';
import { eq, and, or, not, notEq, gt } from 'ember-truth-helpers';
import TrashCan from 'eflex/components/trash-can';
import AddButton from 'eflex/components/add-button';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { isBlank } from 'ramda-adjunct';
import FaIcon from '@fortawesome/ember-fontawesome/components/fa-icon';
import PowerSelect from 'eflex/components/power-select';
import { taskTypes } from 'eflex/constants/tasks/task-types';
import { getOptions, SelectedVariableValueTemplate } from 'eflex/components/task-variable-select';
const deleteAnimation = (animation)=>{
    animation.deleteRecord();
};
const getPreviousVariableDefs = (task, taskRepo)=>{
    return taskRepo.getAllPreviousTasks(task)?.flatMap((_task)=>_task.variableDefs).filter((def)=>!def.isDeleted) ?? [];
};
export default class JemInstructionsConfiguration extends Component {
    @service
    store;
    @service
    intl;
    @service
    taskRepo;
    @tracked
    selectedDynamicObject;
    @tracked
    dataType;
    @tracked
    selectedProcessDataOpt;
    @tracked
    previousVariableDefs = [];
    @tracked
    options = [];
    constructor(){
        super(...arguments);
        this.initializeOptions();
    }
    initializeOptions() {
        this.previousVariableDefs = getPreviousVariableDefs(this.args.triggerConfig.taskConfig.task, this.taskRepo);
        this.options = getOptions(this.previousVariableDefs);
    }
    selectObject = (selected)=>{
        this.selectedDynamicObject = selected;
        const animation = this.animationsForSelectedObject[0];
        if (!isEmpty(animation) && !isBlank(animation)) {
            this.updateTextValue(animation);
            this.validateBomVariableList(animation);
            if (animation?.dataType === DataTypes.PROCESSDATA) {
                this.getProcessDataOption(animation);
            }
        }
    };
    flattenOptions = (options)=>options.flatMap((station)=>station.options.flatMap((task)=>task.options));
    getProcessDataOption = (animation)=>{
        const processDataOptionId = animation?.processDataOptionId;
        const allOptions = this.flattenOptions(this.options);
        this.selectedProcessDataOpt = allOptions.find((opt)=>opt.id === processDataOptionId);
        animation.textValue = this.selectedProcessDataOpt?.name;
    };
    addAnimationForSelectedObject = ()=>{
        this.store.createRecord('work-instruction-animation', {
            workInstructionHardwareTriggerConfig: this.args.triggerConfig,
            object: this.selectedDynamicObject.id,
            event: AnimationEventValues[0],
            animation: AnimationTypeValues[0],
            bolt: this.bolts[0].value,
            dataType: DataTypes.TEXT
        });
    };
    toggleColor = (animationConfig, property, checked)=>{
        animationConfig[property] = checked ? '#000000' : null;
    };
    updateColor = (config, property, event)=>{
        config[property] = event.target.value;
    };
    selectBolt = (config, selected)=>{
        config.bolt = selected.value;
    };
    get isTorqueTask() {
        return this.args.triggerConfig?.taskConfig?.taskType === taskTypes.torque;
    }
    get instructionObjects() {
        const dynamicObjects = this.args.triggerConfig.workInstruction.getDynamicObjectNames();
        dynamicObjects.forEach((obj)=>{
            const animations = this.args.triggerConfig.animations.filter((animation)=>{
                return (!animation.isDeleted && animation.object === obj.id);
            });
            obj.animationCount = animations.length;
        });
        return dynamicObjects;
    }
    get bolts() {
        const bolts = [
            {
                label: this.intl.t('jem.animations.allBolts'),
                value: 'all'
            }
        ];
        for(let i = 1; i <= this.args.boltCount; i++){
            bolts.push({
                label: `${this.intl.t('bolt')} ${i}`,
                value: `${i}`
            });
        }
        return bolts;
    }
    get animationsForSelectedObject() {
        return reject((animation)=>animation.isDeleted || animation.object !== this.selectedDynamicObject?.id || (animation.bolt !== 'all' && Number.parseInt(animation.bolt) > Number.parseInt(this.args.boltCount)))(this.args.triggerConfig.animations);
    }
    validateBomVariableList = (config)=>{
        const triggerConfig = this.args.triggerConfig?.taskConfig;
        const bomVariableList = triggerConfig?.config?.component?.bomSource?.variables || [];
        const selected = config?.selectedValueOption;
        if (triggerConfig.usesComponents && selected !== BOMValues.NAME && selected !== BOMValues.VALUE) {
            if (isEmpty(bomVariableList)) {
                config.selectedValueOption = null;
                config.textValue = null;
            } else {
                config.selectedValueOption = this.getNameFromId(bomVariableList, config.selectedValueOptionId);
            }
        }
    };
    updateTextValue = (config)=>{
        if (config?.dataType !== DataTypes.TEXT) {
            const triggerConfig = this.args.triggerConfig?.taskConfig;
            const selected = config?.selectedValueOption;
            let newValue = null;
            if (!triggerConfig || !selected) {
                return;
            }
            if (triggerConfig.usesComponents) {
                const option = triggerConfig?.configOption;
                switch(selected){
                    case BOMValues.NAME:
                        {
                            newValue = option?.name;
                            break;
                        }
                    case BOMValues.VALUE:
                        {
                            newValue = option?.value ?? this.intl.t(BOMValues.VALUE);
                            break;
                        }
                    default:
                        {
                            newValue = selected;
                        }
                }
            } else if (triggerConfig.usesModels) {
                const model = triggerConfig.configModel;
                newValue = selected === ModelValues.NAME ? model?.name : model?.code;
            }
            if (config.textValue !== newValue) {
                config.textValue = newValue;
            }
        }
    };
    getIdFromName(list, name) {
        return list.find((opt)=>opt.name === name)?.id;
    }
    getNameFromId(list, id) {
        return list.find((opt)=>opt.id === id)?.name;
    }
    setTextValue = (config, value)=>{
        const triggerConfig = config?.workInstructionHardwareTriggerConfig?.taskConfig;
        if (!triggerConfig) {
            return;
        }
        config.selectedValueOption = value;
        const bomVariableList = triggerConfig?.config?.component?.bomSource?.variables || [];
        if (triggerConfig?.usesComponents) {
            if (value === BOMValues.NAME) {
                config.textValue = triggerConfig?.configOption?.name;
                config.selectedValueOptionId = null;
                config.processDataOptionId = null;
            } else if (value === BOMValues.VALUE) {
                config.textValue = triggerConfig?.configOption?.value ?? this.intl.t(BOMValues.VALUE);
                config.selectedValueOptionId = null;
                config.processDataOptionId = null;
            } else {
                config.textValue = value;
                config.processDataOptionId = null;
                config.selectedValueOptionId = this.getIdFromName(bomVariableList, value);
            }
        } else if (triggerConfig?.usesModels) {
            config.textValue = value === ModelValues.NAME ? triggerConfig?.configModel?.name : triggerConfig?.configModel?.code;
        }
    };
    setDataTypeValue = (config, value)=>{
        const triggerConfig = this.args.triggerConfig?.taskConfig;
        config.dataType = value;
        if (value != null && (value == DataTypes.BOMVALUES || value == DataTypes.MODELVALUES)) {
            if (triggerConfig?.configOption?.component?.isAlwaysRun) {
                config.selectedValueOption = this.valueOptions?.[0]?.options?.[0];
                this.setTextValue(config, this.valueOptions?.[0]?.options?.[0]);
            } else {
                config.selectedValueOption = this.valueOptions?.[0];
                this.setTextValue(config, this.valueOptions?.[0]);
            }
        } else if (value == DataTypes.TEXT) {
            config.textValue = null;
        } else if (value == DataTypes.PROCESSDATA) {
            config.selectedValueOption = null;
            config.textValue = this.selectedProcessDataOpt?.name;
        }
    };
    setProcessDataOptions = (config, value)=>{
        this.selectedProcessDataOpt = value;
        config.processDataOptionId = value.id;
        config.selectedValueOptionId = null;
        config.selectedValueOption = null;
        if (value?.name) {
            config.textValue = value.name;
        }
    };
    get dataTypeOptions() {
        const usesComponents = this.args.triggerConfig?.taskConfig?.usesComponents;
        if (usesComponents) {
            return DataTypes.options.filter((opt)=>opt !== DataTypes.MODELVALUES);
        } else {
            return DataTypes.options.filter((opt)=>opt !== DataTypes.BOMVALUES);
        }
    }
    get valueOptions() {
        let bomValueOptions, bomVariableOptions;
        const triggerConfig = this.args?.triggerConfig?.taskConfig;
        if (!triggerConfig?.usesComponents) {
            return ModelValues.options;
        }
        const bomVariableList = triggerConfig?.config?.component?.bomSource?.variables || [];
        const isAlwaysRun = triggerConfig?.configOption?.component?.isAlwaysRun;
        const isComplex = triggerConfig?.component?.isComplex;
        if (!isEmpty(bomVariableList)) {
            const valueSet = new Set(bomVariableList.map((variable)=>variable.name));
            bomVariableOptions = {
                groupName: this.intl.t(BOMValues.BOMVARIABLE),
                options: [
                    ...valueSet
                ]
            };
        }
        if (isAlwaysRun) {
            if (!isBlank(bomVariableOptions)) {
                bomValueOptions = [
                    bomVariableOptions
                ];
            }
        } else {
            bomValueOptions = isComplex ? [
                BOMValues.NAME,
                bomVariableOptions
            ] : [
                ...BOMValues.options,
                bomVariableOptions
            ];
        }
        return bomValueOptions;
    }
    static{
        template_67f4800a22034e7db96f83f11d5e8fa3(`
    <div class="component-jem-instructions-animation" ...attributes>
      <div class="animation-config h-100">
        <BsForm @model={{this}} class="d-flex flex-column h-100" as |form|>
          <div class="row align-items-end mb-3">
            <div class="col min-w-0">
              <label class="form-label text-truncate w-100 mb-0">
                {{t "workInstructions.dynamicObject"}}
              </label>
              <PowerSelect
                class="animation-instruction-object model-specific"
                @dropdownClass="dynamic-objects"
                @options={{this.instructionObjects}}
                @optionLabelPath="name"
                @onChange={{this.selectObject}}
                @matchTriggerWidth={{true}}
                @selected={{findBy "id" this.selectedDynamicObject.id this.instructionObjects}}
                @placeholder={{t "dynamicEvents.selectObject"}}
              as |object|>
                <div class="d-flex align-items-center">
                  <span class="object-name flex-fill text-truncate">
                    {{object.name}}
                  </span>
                  <span class="animation-count badge fs-3 py-1 px-2 ms-2
                    {{if object.animationCount "bg-primary" "bg-gray-400"}}
                  ">
                    {{or object.animationCount 0}}
                  </span>
                </div>
              </PowerSelect>
            </div>
            <div class="col-auto">
              <AddButton
                class="add-animation"
                @onClick={{fn this.addAnimationForSelectedObject @triggerConfig.animations}}
                @disabled={{isBlank this.selectedDynamicObject}}
              >
                {{t "animation"}}
              </AddButton>
            </div>
          </div>

          <div class="eflex-scroll flex-fill bg-gray-100 rounded mb-0 p-2">
            {{#if (gt this.animationsForSelectedObject.length 0) }}
              <div class="row gy-2 flex-column">
                {{#each this.animationsForSelectedObject as |animationConfig|}}
                  <div class="col-auto">
                    <div class="bg-white shadow rounded animation-row p-3">
                      <div class="row g-2 justify-content-end">
                        <div class="col-auto">
                          <BsButton
                            @type="peripheral"
                            @onClick={{fn @playAnimation animationConfig}}
                            class="play-animation d-flex"
                          >
                            <FaIcon @icon="play" @prefix="fas" class="fa-fw" />
                          </BsButton>
                        </div>
                        <div class="col-auto">
                          <TrashCan
                            disabled={{@disabled}}
                            @onDelete={{fn deleteAnimation animationConfig}}
                          />
                        </div>
                      </div>
                      <div class="row flex-column gy-3">
                        <div class="col-auto">
                          <label class="form-label">
                            {{t "event"}}
                          </label>
                          <div class="row align-items-center g-2">
                            {{#if this.isTorqueTask }}
                              <div class="col">
                                <form.element
                                  class="animation-bolt model-specific"
                                  @controlType="power-select"
                                  @options={{this.bolts}}
                                  @optionLabelPath="label"
                                  @onChange={{fn this.selectBolt animationConfig}}
                                  @value={{findBy "value" animationConfig.bolt this.bolts}}
                                as |el|>
                                  <el.control
                                    @disabled={{@disabled}}
                                    @triggerClass="form-control form-control-sm"
                                  />
                                </form.element>
                              </div>
                            {{/if}}
                            <div class="col">
                              <form.element
                                class="animation-event model-specific"
                                @controlType="power-select"
                                @options={{AnimationEventValues}}
                                @model={{animationConfig}}
                                @property="event"
                              as |el|>
                                <el.control
                                  @disabled={{@disabled}}
                                  @triggerClass="form-control form-control-sm"
                                as |boltEvent|>
                                  {{t boltEvent}}
                                </el.control>
                              </form.element>
                            </div>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="row g-2">
                            <div class="col-12">
                              <label class="form-label">
                                {{t "animation"}}
                              </label>
                              <form.element
                                class="animation-type model-specific"
                                @controlType="power-select"
                                @options={{AnimationTypeValues}}
                                @model={{animationConfig}}
                                @property="animation"
                              as |el|>
                                <el.control
                                  @disabled={{@disabled}}
                                  @triggerClass="form-control form-control-sm"
                                as |animation|>
                                  {{t animation}}
                                </el.control>
                              </form.element>
                            </div>
                            <div class="row g-2">
                              {{#if (eq this.selectedDynamicObject.type "Textbox") }}
                                {{#unless (eq animationConfig.animation "reset") }}
                                  <div class="col-12 col-lg-6 col-xl-4 animation-color d-flex flex-column">
                                    <div class=" d-flex">
                                      <form.element
                                        @controlType="checkbox"
                                        @value={{isPresent animationConfig.color}}
                                        @onChange={{fn this.toggleColor animationConfig 'color'}}
                                      as |el|>
                                        <el.control @disabled={{@disabled}} />
                                      </form.element>
                                      <label class="form-label">
                                        {{t "fontColor"}}
                                      </label>
                                    </div>
                                    <input
                                      type="color"
                                      class="square-color-picker sm w-100"
                                      value={{animationConfig.color}}
                                      disabled={{or (not animationConfig.color) @disabled}}
                                      {{on "input" (fn this.updateColor animationConfig 'color')}}
                                    />
                                  </div>
                                {{/unless}}
                              {{/if}}
                              {{#if (not (or
                                (eq this.selectedDynamicObject.type "image")
                                (eq this.selectedDynamicObject.type "straight-line")
                                (eq animationConfig.animation "reset")
                              ))}}
                                <div class="col-12 col-lg-6 col-xl-4 animation-fill-color d-flex flex-column">
                                  <div class="d-flex">
                                    <form.element
                                      @controlType="checkbox"
                                      @value={{isPresent animationConfig.fillColor}}
                                      @onChange={{fn this.toggleColor animationConfig 'fillColor'}}
                                    as |el|>
                                      <el.control @disabled={{@disabled}} />
                                    </form.element>
                                    <label class="form-label">
                                      {{t "imageEditor.fill"}}
                                    </label>
                                  </div>
                                  <input
                                    type="color"
                                    class="square-color-picker sm w-100"
                                    value={{animationConfig.fillColor}}
                                    disabled={{or (not animationConfig.fillColor) @disabled}}
                                    {{on "input" (fn this.updateColor animationConfig 'fillColor')}}
                                  />
                                </div>
                              {{/if}}
                              {{#if (not (or
                                (eq this.selectedDynamicObject.type "image")
                                (eq this.selectedDynamicObject.type "icon")
                                (eq animationConfig.animation "reset")
                              ))}}
                                <div class="col-12 col-lg-6 col-xl-4 animation-stroke-color d-flex flex-column">
                                  <div class=" d-flex">
                                    <form.element
                                      @controlType="checkbox"
                                      @value={{isPresent animationConfig.strokeColor}}
                                      @onChange={{fn this.toggleColor animationConfig 'strokeColor'}}
                                    as |el|>
                                      <el.control @disabled={{@disabled}} />
                                    </form.element>
                                    <label class="form-label">
                                      {{t "imageEditor.stroke"}}
                                    </label>
                                  </div>
                                  <input
                                    type="color"
                                    class="square-color-picker sm square-color-picker-stroke w-100"
                                    value={{animationConfig.strokeColor}}
                                    disabled={{or (not animationConfig.strokeColor) @disabled}}
                                    {{on "input" (fn this.updateColor animationConfig 'strokeColor')}}
                                  />
                                </div>
                              {{/if}}
                              {{#if (eq this.selectedDynamicObject.type "Textbox") }}
                                {{#unless (eq animationConfig.animation "reset") }}
                                  <div class="col-12 col-lg-6 col-xl-4 animation-textbox-color d-flex flex-column">
                                    <div class=" d-flex">
                                      <form.element
                                        @controlType="checkbox"
                                        @value={{isPresent animationConfig.textBoxColor}}
                                        @onChange={{fn this.toggleColor animationConfig 'textBoxColor'}}
                                      as |el|>
                                        <el.control @disabled={{@disabled}} />
                                      </form.element>
                                      <label class="form-label">
                                        {{t "imageEditor.text.textBox"}}
                                      </label>
                                    </div>
                                    <input
                                      type="color"
                                      class="square-color-picker sm w-100"
                                      value={{animationConfig.textBoxColor}}
                                      disabled={{or (not animationConfig.textBoxColor) @disabled}}
                                      {{on "input" (fn this.updateColor animationConfig 'textBoxColor')}}
                                    />
                                  </div>
                                {{/unless}}
                              {{/if}}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row g-2">
                        <div class="row g-2">
                          {{#if (eq this.selectedDynamicObject.type "Textbox") }}
                            {{#unless (eq animationConfig.animation "reset") }}
                              <div class="col-12 col-lg-6">
                                <label class="form-label">
                                  {{t "dataType"}}
                                </label>
                                <form.element
                                  class="data-type model-specific"
                                  @controlType="power-select"
                                  @options={{this.dataTypeOptions}}
                                  @model={{animationConfig}}
                                  @property="dataType"
                                  @onChange={{fn this.setDataTypeValue animationConfig}}
                                as |el|>
                                  <el.control
                                    @disabled={{@disabled}}
                                    @triggerClass="form-control form-control-sm"
                                  as |dataType|>
                                    {{t dataType}}
                                  </el.control>
                                </form.element>
                              </div>
                              {{#let animationConfig.dataType as |animationDataType|}}
                                {{#if (eq animationConfig.dataType "text")}}
                                  <div class="col-12 col-lg-6">
                                    <label class="form-label">
                                      {{t "value"}}
                                    </label>
                                    <form.element
                                      class="text-value model-specific"
                                      @controlType="text"
                                      @model={{animationConfig}}
                                      @property="textValue"
                                      @size="sm"
                                    as |el|>
                                      <el.control
                                        @disabled={{@disabled}}
                                        @triggerClass="form-control form-control-sm"
                                      as |textValue|>
                                        {{t textValue}}
                                      </el.control>
                                    </form.element>
                                  </div>
                                {{else if (or (eq animationDataType "bomValues") (eq animationDataType "modelValues"))}}
                                  <div class="col-12 col-lg-6">
                                    <label class="form-label">
                                      {{t "value"}}
                                    </label>
                                    <form.element
                                      class="option-value model-specific"
                                      @controlType="power-select"
                                      @options={{this.valueOptions}}
                                      @model={{animationConfig}}
                                      @property="selectedValueOption"
                                      @onChange={{fn this.setTextValue animationConfig}}
                                    as |el|>
                                      <el.control
                                        @disabled={{@disabled}}
                                        @triggerClass="form-control form-control-sm"
                                      as |optionValue|>
                                        {{#if (and (eq animationDataType "bomValues")
                                                   (notEq optionValue "optionName") (notEq optionValue "optionValue"))}}
                                          {{optionValue}}
                                        {{else}}
                                          {{t optionValue}}
                                        {{/if}}
                                      </el.control>
                                    </form.element>
                                  </div>
                                {{else if (eq animationDataType "processData") }}
                                  <div class="col-12 col-lg-6">
                                    <label class="form-label">
                                      {{t "value"}}
                                    </label>
                                    <form.element
                                      class="process-data-value model-specific"
                                      @controlType="power-select"
                                      @options={{this.options}}
                                      @optionLabelPath="name"
                                      @model={{animationConfig}}
                                      @value={{this.selectedProcessDataOpt}}
                                      @onChange={{fn this.setProcessDataOptions animationConfig}}
                                    as |el|>
                                      <el.control
                                        @disabled={{@disabled}}
                                        @triggerClass="form-control form-control-sm"
                                        @selectedItemComponent={{SelectedVariableValueTemplate}}
                                      as |processDataValue|>
                                        <span title={{processDataValue.task.parent.name}} class="w-100">
                                          {{processDataValue.name}}
                                        </span>
                                      </el.control>
                                    </form.element>
                                  </div>
                                {{/if}}
                              {{/let}}
                            {{/unless}}
                          {{/if}}
                        </div>
                      </div>
                    </div>
                  </div>
                {{/each}}
              </div>
            {{else}}
              <div class="d-flex align-items-center justify-content-center text-gray-600 text-center w-100 h-100">
                {{if this.selectedDynamicObject
                  (t "dynamicEvents.objectHasNoAnimations")
                  (t "dynamicEvents.selectObject")
                }}
              </div>
            {{/if}}
          </div>
        </BsForm>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
